import Global from './Global';
import Generate from './Generate';
import Payback from './Payback';
import Deposit from './Deposit';
import Withdraw from './Withdraw';
import Send from './Send';
import DsrDeposit from './DsrDeposit';
import DsrWithdraw from './DsrWithdraw';
import DepositAndGenerate from './DepositAndGenerate';

export default {
  global: Global,
  generate: Generate,
  payback: Payback,
  deposit: Deposit,
  withdraw: Withdraw,
  send: Send,
  dsrdeposit: DsrDeposit,
  dsrwithdraw: DsrWithdraw,
  depositAndGenerate: DepositAndGenerate
};
